import { useQuery } from '@tanstack/react-query';
import InitAPI from '../api';

// The old Redux boot fetched the site status exactly once via START, using the boot
// platform, and never re-fetched on platform switch. A GET_SITE_STATUS failure had no
// message handler and was silently ignored. We preserve both traits: a single,
// permanently-fresh ['siteStatus'] query with no retries and no error toast.
function useSiteStatusQuery() {
  return useQuery({
    queryKey: ['siteStatus'],
    queryFn: () => InitAPI.getSiteStatus().then(res => res.data),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
}

export default useSiteStatusQuery;
